import { styled } from "@stitches/react";

export const WrapImage = styled('div', {
  width: "100%",
  minHeight: "50vh",
  '& img': {
    height: 'auto !important',
    minHeight: "inherit !important",
    minWidth: "90% !important",

    width:" auto !important",
    maxHeight: "85% !important",
    objectFit: "contain",
  }
})


export const CloseModalWrapper = styled('div', {
  zIndex: 2,
  height: '42px'
})

export const Content = styled('div', {
  zIndex: 1,
  button: {
    right: "-3px"
  }
})


export const WrapButtons = styled('div', {
  marginTop: 20,
  display: "flex",
  justifyContent: "space-between"
})